module.exports = __webpack_public_path__ + "2e1a9b5d84522b6b80bd4b6fefda50e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/oracle_2024_chart.png
// module id = 1710
// module chunks = 0